export const L10N = {
  ACTION_FIX_FIRST_ERROR: { id: 'common.action.fix_first_error' },
  NOTIFICATION_FIX_FORM_ERRORS: { id: 'common.notification.fix_form_errors' },
};
